import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { $downloadRecipientStore } from '@lib/store';
import { Button, FileInput, Modal } from '@shared/widgets';

interface IForm {
  file: File | undefined;
}

interface Props {
  show: boolean;
  onClose: () => void;
  receipt?: string | null;
  refNum: string;
  onSave: (file?: File, isDeleted?: boolean) => Promise<void>;
  removeReceipt: () => Promise<void>;
}

export const AddReceiptModal = (props: Props) => {
  const [isDeleted, setIsDeleted] = useState<boolean>(false);

  const { control, formState, handleSubmit, setValue, reset } = useForm<IForm>();
  const { t } = useTranslation('reports');

  useEffect(() => {
    if (!props.show) return;
    reset({ file: props.receipt ? ({ name: props.receipt, size: 0 } as File) : undefined });
  }, [props.show]);

  const closeHandler = () => {
    props.onClose();
    reset({ file: undefined });
    setIsDeleted(false);
  };
  const submitHandler = async (data: IForm) => {
    if (data.file == null || data.file instanceof File) await props.onSave(data.file, isDeleted);
    closeHandler();
  };
  const removeHandler = async () => {
    setValue('file', undefined);
    if (props.receipt) {
      props.removeReceipt();
      setIsDeleted(true);
    }
  };
  const downloadHandler = async () => await $downloadRecipientStore.events.downloadRecipient(props.refNum);

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('card.transactions.modals.addReceipt.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='file'
          control={control}
          render={({ field: { value, onChange } }) => (
            <FileInput value={value} onChange={onChange} onRemove={removeHandler} onDownload={props.receipt ? downloadHandler : undefined} />
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('buttons.save', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
